import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class LowSalt extends AlertLogic {
    static type = AlertType.LowSalt;
    static category = AlertCategories.WATER_QUIALITY;
    static contentCategories = [ ContentCategories.WATER_QUALITY ];
    static title = Locale.gettext('Low Salt');

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;
        
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);
        
        // Varying across alert types
        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Low Salt'),
            cardDescription: this.locale.gettext('It may be time for you to add salt'),
            cardIllustration: 'pool_adding_salt',
            detailIcon: 'salt-cell',
            detailDescription: this.locale.gettext('%1$s %2$s is currently reporting %3$s as it\'s salt level.',
                device.Name,
                device.HardwareDevice?.UniqueBusIdentifier ?
                    this.locale.gettext('(Serial port: %1$s, Bus ID: %2$s)', 
                        device.HardwareDevice?.Ports[0]?.Number,
                        device.HardwareDevice?.UniqueBusIdentifier
                    ) :
                    '',
                alert.data?.ActualSaltLevel
            ),
            detailDescription2: this.locale.gettext('Test your water manually to check the salt level of the water, and follow the manufacturer\'s instructions for adding salt if needed.'),
            detailDescription3: this.locale.gettext('Allow 24 hours for the reading to normalize.'),
            // detailDescription4: this.locale.gettext('The recommended salt level is %s.',
            //     alert.data?.DesiredMinimumSaltLevel
            // ),
            actionButtonTitle: false,
            resolveSummary: this.locale.gettext('%1$s salt level is back to normal', device.Name)
        });
        alertInfo.contentCategories = LowSalt.contentCategories;
        return alertInfo;
    }

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device = config.Config.Devices.find(dev => dev.DeviceType === "SaltCell");
        
        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            deviceId: 1,
            entityUuid: device?.UUID,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type: type,
            data: {
                
            }
        }) : null;
    }
}